import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { StyledButton } from "../shared/Button/Button.styles";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  DetailedResultsFetalSexForwardConfirmButton,
  DetailedResultsFetalSexForwardConfirmWrapper,
} from "./DetailedResults.styles";

export const DetailedResultsFetalSexForwardConfirm: React.FC<{
  confirmedEmail: string;
}> = ({ confirmedEmail }) => {
  const { deviceType } = useDeviceHook();
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <DetailedResultsFetalSexForwardConfirmWrapper deviceType={deviceType}>
      <div>
        {GetTypographyContent({
          content: t("results.forwardFetalSex.confirmation.title"),
          size: "h3",
          textColor: "greyMedium",
          isBold: true,
        })}
      </div>
      <div>
        {GetTypographyContent({
          content: t("results.forwardFetalSex.confirmation.sentTo"),
          size: "large",
          textColor: "greyMedium",
        })}
        {GetTypographyContent({
          content: confirmedEmail,
          size: "large",
          textColor: "greyMedium",
          isBold: true,
        })}
      </div>
      <DetailedResultsFetalSexForwardConfirmButton>
        <StyledButton
          variant="outlined"
          size="small"
          $backgroundColor="white"
          $textColor="redMedium"
          onClick={() => history.push("/client/dashboard")}
        >
          {t("results.actions.returnToHomepage")}
        </StyledButton>
      </DetailedResultsFetalSexForwardConfirmButton>
    </DetailedResultsFetalSexForwardConfirmWrapper>
  );
};
